module.exports = {"Total":"Total","Page":"Page","of":"of","No":"No.","Name":"Name","Image":"Image","Code":"Code","Filesize":"*File Size Limit = 10 MB","SelectAll":"Select All","Description":"Description","AddNew":"Add New","RoleList":"Role List","UpdateRole":"Update Role","CreateRole":"Create Role","ViewRole":"View Role","Synco365":"Sync o365 Role","MaxBooking":"Max. Advanced Booking (Days)","MaxDuration":"Max. Duration Per Event (minutes)","Confirmation":"Confirmation","modelDelete":"Do you want to delete this role ?","AvailableRooms":"Available Rooms for Reserve","Require":"Require!!"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/role/ENG.json
// module id = 1321
// module chunks = 120